<template>
  <div class="my_div">
    <el-row type="flex">
      <div class="title">
        <slot name="title"></slot>
      </div>
      <div class="cancel">
        <slot name="cancel"></slot>
      </div>
      <div class="create">
        <slot name="create"></slot>
      </div>
      <div class="button">
        <slot name="button"></slot>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.my_div{
  display: flex;
  flex-flow: column-reverse;
  height: 72px;
  box-shadow: 0 10px 10px -5px #E6E6E1;
}
.title{
  margin-left: 45px;
  font-size: 24px;
}
::v-deep .title label {
  display: block;
  white-space: nowrap;
  width: 600px;
  line-height: 72px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cancel{
  flex: 1;
  text-align: right;
  margin-right: 40px;
  line-height: 72px;
}
.create{
  line-height: 72px;
  padding-right: 20px;
}
.button {
  line-height: 72px;
  padding-right: 20px;
}
</style>
